import MainAgency from '@/pages/MainAgency.tsx'
import { SpinnerProvider } from '@/shared/lib/context/SpinnerContext'
import { AppVersionCheck } from 'common/components/AppVersionCheck.tsx'
import AppProvider from 'common/context/AppContext.tsx'
import UserProvider from 'common/context/UserContext'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <UserProvider agency={false}>
      <AppProvider>
        <AppVersionCheck />
        <SpinnerProvider>
          <MainAgency />
        </SpinnerProvider>
      </AppProvider>
    </UserProvider>
  </BrowserRouter>,
)
